import request from './request'
import env from './env'

// 获取手机号
export function GetPhoneById(data) {
    return request({
        url: '/api/wechat/getPhoneById',
        method: 'POST',
        data: {
            id: data.id,
        }
    })
}

// pc实名补录（获取订单号）
export function NewTransAcctT(data) {
    return request({
        url: '/api/wechat/newTransAcctT',
        method: 'POST',
        data: {
            serviceId: data.phone,
            returnUrl: `${env.prod.baseUrl}${data.url}`
            // returnUrl: `http://localhost:8080/realNameLinkForm`
        }
    })
}

// 个人实名补录（输入手机号）
export function PersonTransAcctT(data) {
    return request({
        url: '/api/wechat/personTransAcctT',
        method: 'POST',
        data: {
            token: data.token,
            serviceId: data.phone,
            returnUrl: `${env.prod.baseUrl}${data.url}`
            // returnUrl: `http://localhost:8080/PersonageRealNameForm`
        }
    })
}

// 实名补录检测结果
export function NewGetImgPath(data) {
    return request({
        url: '/api/wechat/newGetImgPath',
        method: 'POST',
        data: {
            biz_no: data.biz_no,
        }
    })
}


// 检测号码的入网资料和实名认证资料是否一致
export function CheckName(data) {
    return request({
        url: '/api/wechat/checkName',
        method: 'POST',
        data: {
            name: data.name,
            token: data.token,
            idCard: data.idCard,
        }
    })
}

// 实名补录提交
export function NewTransAcctTForm(data) {
    return request({
        url: '/api/wechat/newTransAcctTForm',
        method: 'POST',
        data: {
            biz_no: data.biz_no,
            sparePhone: data.sparePhone,
            id: data.id,
            cityName: data.cityName,
        }
    })
}

// 个人实名补录提交
export function PersonTransAcctTForm(data) {
    return request({
        url: '/api/wechat/personTransAcctTForm',
        method: 'POST',
        data: {
            biz_no: data.biz_no,
            sparePhone: data.sparePhone,
        }
    })
}